import { Outlet } from 'react-router'

import { OutletWrapper } from '@base'

const Extras = () => {
	return (
		<>
			<OutletWrapper>
				<Outlet />
			</OutletWrapper>
		</>
	)
}

export default Extras
